// Purpose: client-side 404.

import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '../components/icons/index.tsx';
import { Button, EmptyState } from '../components/ui/index.ts';

export function NotFound() {
  return (
    <EmptyState
      title="Not found"
      description="The page you requested does not exist or is outside your access."
      action={
        <Link to="/">
          <Button variant="secondary" leftIcon={<ArrowLeftIcon size={16} />}>
            Back to home
          </Button>
        </Link>
      }
    />
  );
}
